/**
 * Document Disciplines Structure
 * Shared structure for DocumentSidebar and DocumentEdit form
 */

export const documentDisciplines = [
  {
    id: "prosjektering_vvs",
    name: "Prosjektering VVS",
    categories: [
      {
        id: "hms",
        name: "HMS",
        chapters: [
          { number: "1", title: "Omfang" },
          {
            number: "4",
            title: "Kontekst",
            subChapters: [
              { number: "4.1", title: "Interessenter" },
              { number: "4.2", title: "Krav" },
              { number: "4.3", title: "Omfang" },
            ],
          },
          {
            number: "5",
            title: "Ledelse",
            subChapters: [
              { number: "5.1", title: "HMS-policy" },
              { number: "5.2", title: "Roller og ansvar" },
              { number: "5.3", title: "Organisasjonsstruktur" },
            ],
          },
          {
            number: "6",
            title: "Planlegging",
            subChapters: [
              {
                number: "6.1",
                title: "Risikovurdering",
                subChapters: [
                  { number: "6.1.1", title: "Generell risikovurdering" },
                  { number: "6.1.2", title: "Spesifikk risikovurdering (VVS)" },
                ],
              },
              {
                number: "6.2",
                title: "SJA",
                subChapters: [
                  { number: "6.2.1", title: "SJA for VVS-installasjoner" },
                ],
              },
              { number: "6.3", title: "Målsetting" },
            ],
          },
          {
            number: "7",
            title: "Støtte",
            subChapters: [
              { number: "7.1", title: "Ressurser" },
              {
                number: "7.2",
                title: "Kompetanse",
                subChapters: [
                  { number: "7.2.1", title: "VVS-kompetanse" },
                  { number: "7.2.2", title: "Sertifiseringer" },
                ],
              },
              { number: "7.3", title: "Bevissthet" },
              { number: "7.4", title: "Kommunikasjon" },
              { number: "7.5", title: "Dokumentert informasjon" },
            ],
          },
          {
            number: "8",
            title: "Operasjoner",
            subChapters: [
              { number: "8.1", title: "Operasjonell planlegging" },
              { number: "8.2", title: "Nødberedskap" },
            ],
          },
          {
            number: "9",
            title: "Evaluering",
            subChapters: [
              { number: "9.1", title: "Overvåking og måling" },
              { number: "9.2", title: "Internrevisjon" },
              { number: "9.3", title: "Ledelsens gjennomgang" },
            ],
          },
          {
            number: "10",
            title: "Forbedring",
            subChapters: [
              { number: "10.1", title: "Generelt" },
              {
                number: "10.2",
                title: "Avvik og korrigerende tiltak",
                subChapters: [
                  { number: "10.2.1", title: "Avvikshåndtering" },
                  { number: "10.2.2", title: "Korrigerende tiltak" },
                ],
              },
              { number: "10.3", title: "Kontinuerlig forbedring" },
            ],
          },
        ],
      },
      {
        id: "ks",
        name: "Kvalitetssystem",
        chapters: [
          { number: "4", title: "Kontekst" },
          { number: "5", title: "Ledelse" },
          { number: "6", title: "Planlegging" },
          {
            number: "7",
            title: "Støtte",
            subChapters: [
              { number: "7.2", title: "Kompetanse" },
              { number: "7.5", title: "Dokumentert informasjon" },
            ],
          },
          {
            number: "8",
            title: "Operasjoner",
            subChapters: [
              {
                number: "8.2",
                title: "Produkt- og tjenestekrav",
                subChapters: [
                  { number: "8.2.1", title: "VVS-prosjekteringskrav" },
                ],
              },
              {
                number: "8.3",
                title: "Design og utvikling",
                subChapters: [
                  { number: "8.3.1", title: "VVS-designprosess" },
                ],
              },
              { number: "8.4", title: "Kontroll av eksterne prosesser" },
            ],
          },
          { number: "9", title: "Evaluering" },
          { number: "10", title: "Forbedring" },
        ],
      },
      {
        id: "mil",
        name: "Miljøstyring",
        chapters: [
          {
            number: "6",
            title: "Planlegging",
            subChapters: [
              {
                number: "6.1",
                title: "Miljøaspekter",
                subChapters: [
                  { number: "6.1.1", title: "VVS-miljøaspekter" },
                ],
              },
            ],
          },
          {
            number: "8",
            title: "Operasjoner",
            subChapters: [
              { number: "8.1", title: "Operasjonell planlegging" },
            ],
          },
        ],
      },
      {
        id: "lov",
        name: "Lover og Forskrifter",
        chapters: [
          {
            number: "4",
            title: "Kontekst",
            subChapters: [
              { number: "4.2", title: "Krav" },
              { number: "4.2.1", title: "Byggeforskrifter" },
              { number: "4.2.2", title: "VVS-forskrifter" },
              { number: "4.2.3", title: "Energiforskrifter" },
            ],
          },
          {
            number: "6",
            title: "Planlegging",
            subChapters: [
              { number: "6.1.3", title: "Overholdelse av krav" },
            ],
          },
        ],
      },
      {
        id: "kom",
        name: "Kompetanse",
        chapters: [
          {
            number: "7",
            title: "Støtte",
            subChapters: [
              {
                number: "7.2",
                title: "Kompetanse",
                subChapters: [
                  { number: "7.2.1", title: "VVS-prosjekteringskompetanse" },
                  { number: "7.2.2", title: "Sertifiseringer" },
                ],
              },
            ],
          },
        ],
      },
    ],
  },
  {
    id: "utførende_ventilasjon",
    name: "Utførende ventilasjon",
    categories: [
      {
        id: "hms",
        name: "HMS",
        chapters: [
          { number: "1", title: "Omfang" },
          {
            number: "4",
            title: "Kontekst",
            subChapters: [
              { number: "4.1", title: "Interessenter" },
              { number: "4.2", title: "Krav" },
              { number: "4.3", title: "Omfang" },
            ],
          },
          {
            number: "5",
            title: "Ledelse",
            subChapters: [
              { number: "5.1", title: "HMS-policy" },
              { number: "5.2", title: "Roller og ansvar" },
              { number: "5.3", title: "Organisasjonsstruktur" },
            ],
          },
          {
            number: "6",
            title: "Planlegging",
            subChapters: [
              {
                number: "6.1",
                title: "Risikovurdering",
                subChapters: [
                  { number: "6.1.1", title: "Generell risikovurdering" },
                  { number: "6.1.2", title: "Spesifikk risikovurdering (Ventilasjon)" },
                  { number: "6.1.3", title: "Risikovurdering ved montering" },
                ],
              },
              {
                number: "6.2",
                title: "SJA",
                subChapters: [
                  { number: "6.2.1", title: "SJA for ventilasjonsinstallasjoner" },
                  { number: "6.2.2", title: "SJA for vedlikehold av ventilasjon" },
                  { number: "6.2.3", title: "SJA for arbeid i høyden" },
                ],
              },
              { number: "6.3", title: "Målsetting" },
            ],
          },
          {
            number: "7",
            title: "Støtte",
            subChapters: [
              { number: "7.1", title: "Ressurser" },
              {
                number: "7.2",
                title: "Kompetanse",
                subChapters: [
                  { number: "7.2.1", title: "Ventilasjonskompetanse" },
                  { number: "7.2.2", title: "Sertifiseringer" },
                  { number: "7.2.3", title: "Høydearbeid-kompetanse" },
                ],
              },
              { number: "7.3", title: "Bevissthet" },
              { number: "7.4", title: "Kommunikasjon" },
              { number: "7.5", title: "Dokumentert informasjon" },
            ],
          },
          {
            number: "8",
            title: "Operasjoner",
            subChapters: [
              { number: "8.1", title: "Operasjonell planlegging" },
              { number: "8.1.1", title: "Planlegging av ventilasjonsinstallasjon" },
              { number: "8.1.2", title: "Planlegging av vedlikehold" },
              { number: "8.2", title: "Nødberedskap" },
              { number: "8.2.1", title: "Nødberedskap ved arbeid i høyden" },
            ],
          },
          {
            number: "9",
            title: "Evaluering",
            subChapters: [
              { number: "9.1", title: "Overvåking og måling" },
              { number: "9.1.1", title: "Overvåking av ventilasjonsarbeid" },
              { number: "9.2", title: "Internrevisjon" },
              { number: "9.3", title: "Ledelsens gjennomgang" },
            ],
          },
          {
            number: "10",
            title: "Forbedring",
            subChapters: [
              { number: "10.1", title: "Generelt" },
              {
                number: "10.2",
                title: "Avvik og korrigerende tiltak",
                subChapters: [
                  { number: "10.2.1", title: "Avvikshåndtering" },
                  { number: "10.2.2", title: "Korrigerende tiltak" },
                ],
              },
              { number: "10.3", title: "Kontinuerlig forbedring" },
            ],
          },
        ],
      },
      {
        id: "ks",
        name: "Kvalitetssystem",
        chapters: [
          { number: "4", title: "Kontekst" },
          { number: "5", title: "Ledelse" },
          { number: "6", title: "Planlegging" },
          {
            number: "7",
            title: "Støtte",
            subChapters: [
              { number: "7.2", title: "Kompetanse" },
              { number: "7.5", title: "Dokumentert informasjon" },
            ],
          },
          {
            number: "8",
            title: "Operasjoner",
            subChapters: [
              {
                number: "8.2",
                title: "Produkt- og tjenestekrav",
                subChapters: [
                  { number: "8.2.1", title: "Krav til ventilasjonsinstallasjon" },
                  { number: "8.2.2", title: "Kvalitetskrav ved utførelse" },
                ],
              },
              {
                number: "8.5",
                title: "Produksjon og levering av tjenester",
                subChapters: [
                  { number: "8.5.1", title: "Kontroll av ventilasjonsinstallasjon" },
                  { number: "8.5.2", title: "Kontroll av vedlikehold" },
                ],
              },
              { number: "8.6", title: "Utgivelse av produkter og tjenester" },
              { number: "8.7", title: "Kontroll av ikke-konforme produkter og tjenester" },
            ],
          },
          { number: "9", title: "Evaluering" },
          { number: "10", title: "Forbedring" },
        ],
      },
      {
        id: "mil",
        name: "Miljøstyring",
        chapters: [
          {
            number: "6",
            title: "Planlegging",
            subChapters: [
              {
                number: "6.1",
                title: "Miljøaspekter",
                subChapters: [
                  { number: "6.1.1", title: "Ventilasjonsmiljøaspekter" },
                  { number: "6.1.2", title: "Avfallshåndtering ved installasjon" },
                ],
              },
            ],
          },
          {
            number: "8",
            title: "Operasjoner",
            subChapters: [
              { number: "8.1", title: "Operasjonell planlegging" },
              { number: "8.1.1", title: "Miljømessig planlegging" },
            ],
          },
        ],
      },
      {
        id: "lov",
        name: "Lover og Forskrifter",
        chapters: [
          {
            number: "4",
            title: "Kontekst",
            subChapters: [
              { number: "4.2", title: "Krav" },
              { number: "4.2.1", title: "Byggeforskrifter" },
              { number: "4.2.2", title: "Ventilasjonsforskrifter" },
              { number: "4.2.3", title: "Arbeidsmiljøforskrifter" },
            ],
          },
          {
            number: "6",
            title: "Planlegging",
            subChapters: [
              { number: "6.1.3", title: "Overholdelse av krav" },
            ],
          },
        ],
      },
      {
        id: "kom",
        name: "Kompetanse",
        chapters: [
          {
            number: "7",
            title: "Støtte",
            subChapters: [
              {
                number: "7.2",
                title: "Kompetanse",
                subChapters: [
                  { number: "7.2.1", title: "Ventilasjonsinstallasjonskompetanse" },
                  { number: "7.2.2", title: "Vedlikeholdskompetanse" },
                  { number: "7.2.3", title: "Sertifiseringer" },
                ],
              },
            ],
          },
        ],
      },
    ],
  },
];

/**
 * Helper function to get all chapters from a category structure
 * Returns flat array of chapter numbers
 */
export const getChaptersFromCategory = (category) => {
  const chapters = [];
  
  const extractChapters = (chapterList) => {
    chapterList.forEach((chapter) => {
      chapters.push(chapter.number);
      const nested = chapter.sub_chapters || chapter.subChapters || [];
      if (nested.length > 0) {
        extractChapters(nested);
      }
    });
  };
  
  if (category && category.chapters) {
    extractChapters(category.chapters);
  }
  
  return chapters;
};

/**
 * Helper function to get sub-chapters for a given chapter
 */
export const getSubChapters = (disciplineId, categoryId, chapterNumber) => {
  const discipline = documentDisciplines.find((d) => d.id === disciplineId);
  if (!discipline) return [];
  
  const category = discipline.categories.find((c) => c.id === categoryId);
  if (!category) return [];
  
  const findChapter = (chapters, targetNumber) => {
    for (const chapter of chapters) {
      if (chapter.number === targetNumber) {
        return chapter;
      }
      const nested = chapter.sub_chapters || chapter.subChapters || [];
      if (nested.length > 0) {
        const found = findChapter(nested, targetNumber);
        if (found) return found;
      }
    }
    return null;
  };
  
  const chapter = findChapter(category.chapters, chapterNumber);
  return chapter?.sub_chapters || chapter?.subChapters || [];
};



